import { useState, useEffect } from "react"
import { Route, Routes } from "react-router-dom"

import {
    Psychologist,
    FetchSearchProfilesResponse,
    RequestStatus,
    SlotType,
} from "utils/interfaces"
import { Spinner } from "components/Spinner"
import { SurveyResultsPage } from "modules/SelectionOfPsychologists/SurveyResultsPage"
import { Cards } from "modules/SelectionOfPsychologists/Cards"
import { Img } from "ui-kit/components-branded/index"
import { BookingProvider } from "modules/Booking"
import { CreatePortalAfterComponent, Footer, Layout } from "components"
import { AFTER_FOOTER } from "components/Footer/components/AfterFooter/constants"
import { WaitListForm } from "pages/FreePsysPage/WaitListForm"
import { isBookingAvailable } from "utils/bookingAvailable"
import { useDidMount, useSearchParams } from "utils/customHooks"
import { getRootPath } from "utils/utils"
import { APP_STATUSES, useAppStatusContext } from "utils/AppStatusContext"
import { SURVEY_URL } from "utils/env-management"
import { httpClient } from "utils/infrastructure/httpClient"

const SHOW_RESERVED_PSYS_PARAM_NAME = "reserved"

export function FreePsysPage() {
    const [, { push }] = useAppStatusContext()
    const [profiles, setProfiles] = useState<Psychologist[]>([])
    const [status, setStatus] = useState<RequestStatus>("idle")
    const params = useSearchParams()
    const reserved = !!params.get(SHOW_RESERVED_PSYS_PARAM_NAME)

    useDidMount(() => {
        setStatus("loading")
        httpClient
            .get<FetchSearchProfilesResponse>(
                reserved ? "psychologist/volunteers?reserved=1" : "psychologist/volunteers"
            )
            .then((data) => {
                if (data.profiles) {
                    setProfiles(
                        data.profiles.filter((psy) => isBookingAvailable(psy, [SlotType.Free]))
                    )
                }
                setStatus("ready")
            })
            .catch(() => setStatus("error"))
    })

    useEffect(() => {
        if (status === "error") {
            push?.(APP_STATUSES.error)
        }
    }, [status])

    return (
        <Layout>
            {(() => {
                switch (status) {
                    case "loading":
                        return <Spinner text="Загрузка психологов" />
                    case "ready":
                        return (
                            <>
                                <Routes>
                                    <Route
                                        path="/psychologists/free/booking"
                                        element={(() => {
                                            const params = new URLSearchParams(
                                                window.location.search
                                            )
                                            const psy = profiles.find(
                                                ({ hash_id }) => hash_id === params.get("hash_id")
                                            )
                                            if (!psy) return null
                                            return (
                                                <CreatePortalAfterComponent
                                                    idPortalName={AFTER_FOOTER}
                                                >
                                                    <BookingProvider key={psy.hash_id} psy={psy} />
                                                </CreatePortalAfterComponent>
                                            )
                                        })()}
                                    />
                                    <Route
                                        path="/psychologists/free"
                                        element={
                                            profiles.length > 0 ? (
                                                <SurveyResultsPage
                                                    header={
                                                        <>
                                                            <Img
                                                                src="attention.png"
                                                                className="whitelist-form__img"
                                                            />{" "}
                                                            <br />
                                                            Этот проект для тех, кто испытывает
                                                            сильную тревогу и&nbsp;стресс из-за
                                                            событий 22.03.2024
                                                            <hr className="whitelist-form__sep" />
                                                            Не&nbsp;записывайтесь, если
                                                            вы&nbsp;можете позволить себе{" "}
                                                            <a href={SURVEY_URL}>
                                                                платную консультацию
                                                            </a>
                                                            . Оставьте консультацию тому,
                                                            у&nbsp;кого сейчас нет возможности
                                                            заплатить.
                                                        </>
                                                    }
                                                    body={<Cards profiles={profiles} freeBooking />}
                                                    showDiscount={false}
                                                />
                                            ) : (
                                                <>
                                                    <div className="survey-results-header__wrapper">
                                                        <div className="px-3">
                                                            <header className="survey-results-header justify-content-center">
                                                                <a
                                                                    href={getRootPath()}
                                                                    className="survey-results-header__logo"
                                                                >
                                                                    alter
                                                                </a>
                                                            </header>
                                                        </div>
                                                    </div>
                                                    <WaitListForm reserved={reserved} />
                                                </>
                                            )
                                        }
                                    />
                                </Routes>
                                <Footer />
                            </>
                        )
                    default:
                        return null
                }
            })()}
        </Layout>
    )
}
